export const googleTagManager = {
    gtmEvent,
    sendSearchResultsLoadedEvent,
};

function gtmEvent(event, profileId, isProfileLocked) {
    if (typeof window === 'undefined' || typeof window.dataLayer === 'undefined') {
        return;
    }

    const eventObject = {
        event: event,
        country: window.cou,
        locked: false,
    };

    if (profileId) {
        eventObject.profileId = profileId;
    }

    if (isProfileLocked) {
        eventObject.locked = isProfileLocked;
    }

    window.dataLayer.push(eventObject);
}

function sendSearchResultsLoadedEvent(searchResultCount) {
    if (typeof window === 'undefined' || typeof window.dataLayer === 'undefined') {
        return;
    }

    window.dataLayer.push({
        event: 'searchResultsLoaded',
        searchResultCount: searchResultCount,
    });
}
